var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('a',{on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.formatInvoice(_vm.invoice)))])])}
var staticRenderFns = []

export { render, staticRenderFns }